export default "__VITE_ASSET__b3f51Vt5__"